import { useState, memo } from 'react'
import { useRouter } from 'next/router'

// Components
import Loader from '../../newLoader/Loader'
// Utils
import query from '@/utils/query'
import CityOptionsModal from './lib/cityOptionsModal'
import { capitalizeFirstLetterOfTitle, slugConverter } from '@utils'
import { statesByCountry, ICitiesByState } from '@/utils/countries_and_states'
import { GET_VETERINARIANS } from '@graphql'

import styles from './searchInputByCity.module.scss'

interface ISearchInputByCity {
  citiesByState?: ICitiesByState[]
}

export default memo(function SearchInputByCity({
  citiesByState,
}: ISearchInputByCity) {
  const router = useRouter()
  const currentState = router.query.state as string

  const [showError, setShowError] = useState(false)
  const [showOptions, setShowOptions] = useState(false)
  const [inputText, setInputText] = useState('')
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState('')

  const stateByUS = statesByCountry[0].states
  const stateByCA = statesByCountry[1].states

  const fetchData = async (location) => {
    setLoading(true)
    const { getVeterinarians } = await query({
      query: GET_VETERINARIANS,
      variables: {
        location,
      },
    })
    setLoading(false)

    // if search by name city or state  = EXAMPLE : Alabama / Miami
    if (getVeterinarians && location.length > 2) {
      const nameStateUS = stateByUS.filter(
        (elem) => elem.label === capitalizeFirstLetterOfTitle(location)
      )
      const nameStateCA = stateByCA.filter(
        (elem) => elem.label === capitalizeFirstLetterOfTitle(location)
      )

      const state = currentState

      const findCity = getVeterinarians.filter(
        (elem) =>
          elem.location.city ===
          capitalizeFirstLetterOfTitle(location.toLowerCase())
      )
      const city =
        findCity.length > 0
          ? findCity[0]?.location.city
          : capitalizeFirstLetterOfTitle(location.toLowerCase())

      if (nameStateUS.length > 0 || nameStateCA.length > 0) {
        return router.push(
          `${nameStateUS[0]?.value ? nameStateUS[0]?.value.toLowerCase() : nameStateCA[0]?.value.toLowerCase()}`
        )
      }
      // if search city + state = EXAMPLE: orlando, fl / orlando, Florida
      if (location.includes(',')) {
        const array = location.split('')
        const index = array.indexOf(',')
        const city = capitalizeFirstLetterOfTitle(
          array.slice(0, index).join('')
        )
        const state = array
          .slice(index + 1, array.length)
          .join('')
          .trim()

        const nameStateUS = stateByUS.filter(
          (elem) => elem.label === capitalizeFirstLetterOfTitle(state)
        )
        const nameStateCA = stateByCA.filter(
          (elem) => elem.label === capitalizeFirstLetterOfTitle(state)
        )

        return router.push(
          `${state.length > 2 ? (nameStateUS[0] ? nameStateUS[0].value : nameStateCA[0].value) : state.toUpperCase()}/${slugConverter(city).toLowerCase()}`
        )
      } else {
        return city
          ? router.push(
              `${state.toLowerCase()}/${slugConverter(city).toLowerCase()}`
            )
          : handleShowError()
      } // if search by state slug. EXAMPLE = ON
    } else if (getVeterinarians && location.length === 2) {
      const slugState =
        stateByUS?.some((elem) => elem.value === location.toUpperCase()) ||
        stateByCA?.some((elem) => elem.value === location.toUpperCase())
      return slugState
        ? router.push(`${location.toLowerCase()}`)
        : handleShowError()
    } else {
      handleShowError()
    }
  }

  // HANDLE SHOW ERROR ZIPCODE BANNER
  function handleShowError() {
    setShowError(true)
    setTimeout(() => {
      setShowError(false)
    }, 4000)
  }

  return (
    <>
      {loading && (
        <div className={styles.loader}>
          <Loader theme="tall" />
        </div>
      )}

      <form
        className={styles.field}
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault()
          fetchData(data)
        }}
      >
        <input
          type="search"
          value={data}
          onChange={(e) => {
            const lowerCase = e.target.value.toLowerCase()
            setShowOptions(e.target.value.length > 0)
            setInputText(lowerCase)
            setData(e.target.value)
          }}
        />
        <div className={styles.icon} />
        {data.length === 0 && <span>Search City</span>}
      </form>
      {showOptions && (
        <CityOptionsModal
          query={inputText}
          currentState={currentState}
          citiesByState={citiesByState}
          setShowOptions={setShowOptions}
        />
      )}
      {showError && (
        <div onClick={() => setShowError(false)} className={styles.errorMess}>
          {' '}
          <img src="/search/alert-circle.svg" alt="alert circle" />
          State or City not found
        </div>
      )}
    </>
  )
})
